import { CommonModule } from '@angular/common';
import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { Params } from '@angular/router';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { ModalController } from '@ionic/angular/standalone';
import { AppCommonModule } from '../common.module';
import { MainDialogComponent } from '../components/main-dialog/main-dialog.component';
import { adminMenu } from '../menu/admin';
import { contractorAdminMenu } from '../menu/contractor-admin';
import { managerMenu } from '../menu/manager';
import { MenuItem } from '../menu/menu.item.model';
import { residentMenu } from '../menu/resident';
import { superAdminMenu } from '../menu/super-admin';
import { supervisorMenu } from '../menu/supervisor';
import { workerMenu } from '../menu/worker';
import { ClientsService } from '../services/clients.service';
import { NavigationService } from '../services/navigation.service';
import { UsersService } from '../services/users.service';
import { companyAdmins, companyManagers, Roles } from '../utility/role';

@Component({
  selector: 'app-nav-dialog',
  templateUrl: './nav.dialog.html',
  styleUrls: ['./nav.dialog.scss'],
  imports: [
    AppCommonModule,
    CommonModule, MainDialogComponent,
  ],
})
export class NavDialogComponent implements OnInit {
  private clientsService = inject(ClientsService);
  private _modal = inject(ModalController);
  private navigationService = inject(NavigationService);
  private usersService = inject(UsersService);

  readonly companyAdmins = companyAdmins;
  readonly companyManagers = companyManagers;

  readonly appMenu = {
    admin: adminMenu,
    contractorAdmin: contractorAdminMenu,
    manager: managerMenu,
    superAdmin: superAdminMenu,
    worker: workerMenu,
    supervisor: supervisorMenu,
    resident: residentMenu,
  };

  client = computed(() => this.clientsService.clientS());
  role = this.usersService.role;

  version = signal<string>(null);

  selectedItem = signal<MenuItem>(null);

  ngOnInit(): void {
    if (Capacitor.isNativePlatform()) {
      App.getInfo().then((info) => this.version.set(info.version));
    }
  }

  navigate(route: string[], queryParams?: Params) {
    this.navigationService.navigate(route, { queryParams }).then(() => this.dismiss());
  }

  onItem(item: MenuItem) {
    const user = this.usersService.currentUserS();
    if ([Roles.superAdmin].includes(user.role)) {
      if (item.route) {
        this.navigate([item.route], item.queryParams);
      } else if (item.children?.length > 0) {
        this.selectedItem.set(item);
      }
    } else {
      if (item.route) {
        this.navigate([item.route], item.queryParams);
      } else if (item.children?.length > 0) {
        this.selectedItem.set(item);
      }
    }
  }

  dismiss(back = false) {
    if (back && this.selectedItem() != null) {
      this.selectedItem.set(null);
      return;
    }
    this._modal.dismiss();
  }
}
